import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useState } from 'react'
import OverviewStats from '../components/OverviewStats'
import RecentVisitsTable from '../components/RecentVisitsTable'
import { useAuth } from '../../auth'
import { toast } from 'react-toastify'
import {
  getStatisticsDataRoom,
  showRecentVisits,
  getStatisticsDataRoomTimeSpent,
} from '../core/_requests'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import brandingConfig from '../../../../config/brandingConfig'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'

function DataRoomsOverview() {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { companyId} = useAuth()
  const [progress, setProgress] = useState<string>('last_week')
  const [statisticsDataRoom, setStatisticsDataRoom] = useState<any>([])
  const [statisticDataRoomLoading, setStatisticDataRoomLoading] = useState(false)
  const [statisticsDataRoomTimeSpent, setStatisticsDataRoomTimeSpent] = useState<any>([])
  const [statisticDataRoomTimeSpentLoading, setStatisticDataRoomLoadingTimeSpent] = useState(false)
  const [showVisitsData, setShowVisitsData] = useState<any>([])
  const [contentVisited, setContentVisited] = useState<number>(0)
  const [getVisitLoading, setgetVisitLoading] = useState(false)

  const getAllStatisticsDataRoom = async () => {
    setStatisticDataRoomLoading(true)
    try {
      if (companyId && progress) {
        const {
          data: { data, success, errors },
        } = await getStatisticsDataRoom(companyId, progress)
        if (success) {
          setStatisticDataRoomLoading(false)
          setStatisticsDataRoom(data)
        } else {
          setStatisticDataRoomLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      setStatisticDataRoomLoading(false)
      console.log(err)
    }
  }

  const getAllStatisticsTimeSpentDataRoom = async () => {
    setStatisticDataRoomLoadingTimeSpent(true)
    try {
      if (companyId && progress) {
        const {
          data: { data, success, errors },
        } = await getStatisticsDataRoomTimeSpent(companyId, progress)
        if (success) {
          setStatisticDataRoomLoadingTimeSpent(false)
          setStatisticsDataRoomTimeSpent(data)
        } else {
          setStatisticDataRoomLoadingTimeSpent(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      setStatisticDataRoomLoadingTimeSpent(false)
      console.log(err)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([getAllStatisticsDataRoom(), getAllStatisticsTimeSpentDataRoom()])
    }

    fetchData()
  }, [progress, companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getShowVisitsData = async (companyId: any) => {
    setgetVisitLoading(true)
    try {
      const {
        data: { data, success: successData, errors: errorsData },
      } = await showRecentVisits(companyId)
      if (successData) {
        setShowVisitsData(data?.first25Visits)
        setContentVisited(data?.uniqueContentIdsArray?.length)
      } else {
        errorsData.forEach((error: string) => {
          toast.error(error)
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setgetVisitLoading(false)
    }
  }

  useEffect(() => {
    getShowVisitsData(companyId)
  }, [companyId]) // eslint-disable-line

  const loading = statisticDataRoomLoading || statisticDataRoomTimeSpentLoading

  return (
    <>
      <div className='data-rooms-overview-wrapper pt-0 px-6'>
        <div className='Page_ToolBar-wrapper d-md-flex flex-row align-items-center justify-content-between'>
          <div className='Page_ToolBar-left'>
            {/* <h5 className='mb-0 dark_text_color'>{formatMessage({id: 'Overview'})}</h5> */}
            <h4 className='mb-4'> {formatMessage({ id: 'Overview' })}</h4>
            <p className='fw-semibold align-items-center d-flex font-size-12 text-primary'>
              <Link to='/' className='text-primary'>
                {formatMessage({ id: 'Home' })}
              </Link>
              <span className='h-1px bullet mx-2'></span>
              <span className='text-muted font-size-12'>
                {formatMessage({ id: 'Data Rooms Overview' })}
              </span>
            </p>
            {/* <ul className='breadcrumb breadcrumb-line text-muted fs-6 fw-bold'>
              <li className='breadcrumb-item pe-3'>
                <Link to={`/`} className='pe-3 item_link'>
                  {formatMessage({id: 'Home'})}
                </Link>
              </li>
              <li className='breadcrumb-item pe-3 text-muted '>
                {formatMessage({id: 'Data Rooms Overview'})}
              </li>
              </ul> */}
          </div>
          <div className='Page_ToolBar-right d-flex flex-md-row flex-column align-items-md-center justify-content-md-end justify-content-between gap-2'>
            <p className='m-0 mx-1 dark_text_color'>
              {formatMessage({ id: 'Current week compared to' })}
            </p>
            <select
              className='form-select form-select-sm form-select-solid height-36 bg-white border-1 border-dark border-opacity-10 '
              data-control='select2'
              data-placeholder=''
              data-hide-search='true'
              value={progress}
              onChange={(e) => setProgress(e.target.value)}
            >
              <option value='last_week'>{formatMessage({ id: 'Last week' })}</option>
              <option value='this_week'>{formatMessage({ id: 'Last to Last Week' })}</option>
            </select>
            <button
              className='btn bg-primary custom-button-property rounded font-size-13 text-white font-weight-400 height-36 d-flex align-items-center justify-content-center '
              onClick={() => {
                navigate('/data-rooms/files')
              }}
            >
              {formatMessage({ id: 'Add new file' })}
            </button>
          </div>
        </div>

          <InfoCard2
            title={formatMessage({ id: 'Data Room Overview and Insights' })}
            className='mb-0'
            desc={formatMessage({
              id: 'Monitor document sharing, track views, and manage secure data rooms with the Data Room dashboard. This feature can be turned off in settings for a more streamlined experience.',
            })}
            slug={brandingConfig.helpLinks.dataRoomDashboardOverview}
          />

        {loading ? (
          <div className='data-rooms-stats-grid d-flex flex-md-row flex-column'>
          {Array.from({ length: 2 }).map((_, index) => (
            <div key={index} className='bg-white stats-card-wrapper rounded w-100'>
              <div className='stats-card-top mb-3'>
                <Skeleton
                  height={20}
                  className='mb-2'
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
                <div className='w-100'>
                  <Skeleton
                    height={32}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </div>
              </div>        
              <Skeleton
                height={160}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </div>
          ))}
        </div>
        ) : (
          <OverviewStats
            statisticsDataRoom={statisticsDataRoom}
            statisticsDataRoomTimeSpent={statisticsDataRoomTimeSpent}
          />
        )}
        <RecentVisitsTable
          data={showVisitsData}
          getVisitLoading={getVisitLoading}
          contentVisited={contentVisited}
        />
      </div>
    </>
  )
}

export default DataRoomsOverview
